import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { EMPTY } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import * as RascunhoAnaliseActions from '../actions/rascunho-analise.actions';

@Injectable()
export class RascunhoAnaliseEffects {
  constructor(private actions$: Actions, private http: HttpClient) {}

  @Effect()
  loadData$ = this.actions$.pipe(
    ofType(RascunhoAnaliseActions.loadRascunhosEmAnalise.type),
    mergeMap(
      (
        action: ReturnType<typeof RascunhoAnaliseActions.loadRascunhosEmAnalise>
      ) => {
        let params = new HttpParams()
          .set('pagina', (action.pageNumber || 0).toString())
          .set('tamanho-pagina', (action.pageSize || 5).toString())
          .set('direcao-ordenacao', action.direcaoOrdenacao || 'DESC')
          .set('ordenacao', action.atributoOrdenacao || 'CNES');

        if (action.conteudoLivre)
          params = params.set('conteudoLivre', action.conteudoLivre);
        if (action.tipoEstabelecimento)
          params = params.set(
            'tipo-estabelecimento',
            action.tipoEstabelecimento
          );
        if (action.novoCadastro)
          params = params.set('novo-cadastro', action.novoCadastro);
        if (action.cadastroAtualizado)
          params = params.set('cadastro-atualizado', action.cadastroAtualizado);
        if (action.semAlteracao)
          params = params.set('sem-alteracao', action.semAlteracao);

        return this.http
          .get<RascunhoAnaliseResponse>(
            `${environment.urlBaseNova}/cnes/estabelecimentos/rascunhos-em-analise`,
            { params }
          )
          .pipe(
            map((data) =>
              RascunhoAnaliseActions.loadRascunhosEmAnaliseSuccess({ data })
            ),
            catchError((error) => EMPTY)
          );
      }
    )
  );
}
